import React, { useState, useMemo, useContext, useRef } from "react";
import { ApolloConsumer } from "@apollo/client";
import ReactTooltip from "react-tooltip";
import momentTimezone from "moment-timezone";
import moment from "moment";
import { CasesContext } from "../../CasesContext";
import "./../../../../components/Cases/cases.scss";
import getDocument from "../../../Utils/DocumentLink";
import Dot from "../../NotificationDot";
import { FaRegBell } from "react-icons/fa";

import {
  GET_SUBMITTED_PAGINATED_DATA,
  GET_HISTORICAL_PAGINATED_DATA,
  GET_INITIATED_PAGINATED_DATA,
  GET_PRESUBMITTED_PAGINATED_DATA,
} from "../../../../screens/Cases/queries";

import { StyledAccordion } from "../../../../global/css/component/Table";

import { FaSpinner, FaDownload } from "react-icons/fa";
import { ReactTable } from "../../../SimpleForm/ReactTable/index.js";

function HousingInspectionTable(props) {
  const [primaryHousing, setPrimary] = useState([]);
  const [secondaryHousing, setSecondary] = useState([]);
  // const [accordionHousingNotes, setAccordionNote] = useState();
  // const [accordionHousingDocs, setAccordionDoc] = useState();
  const { searchText, housing, manualPagination } = props;

  // Filtering documents to only see Housing Inspection related ones
  if (Array.isArray(housing?.docs) && housing?.docs?.length > 0) {
    let obj = { docs: [] };
    const allDocs = housing.docs;
    for (let i = 0; i < allDocs.length; i++) {
      for (let item in allDocs[i]) {
        if (
          item === "docCategory" &&
          allDocs[i][item] === "Housing Inspection"
        ) {
          if (Array.isArray(obj?.docs) && obj?.docs.length > 0) {
            obj.docs.push(allDocs[i]);
          } else {
            obj.docs = [allDocs[i]];
          }
        }
      }
    }
    housing.docs = obj.docs;
  }

  if (housing?.housingLocations) {
    //typename needs to be deleted so emptyCheck can then check all the other properties for null
    delete housing.housingLocations.__typename;
    const emptyCheck = Object.values(housing.housingLocations).every(
      (x) => x === null || x === ""
    );
    if (emptyCheck) delete housing.housingLocations;
    else {
      //data manipulation of addm b housing standards into 1 array
      let addmLocations = housing["housingLocations"];

      for (let i = 0; i < addmLocations.length; i++) {
        for (let item in addmLocations[i]) {
          if (
            (item.includes("addmbHousingComply") ||
              item.includes("addmbIsCompliance")) &&
            typeof addmLocations[i][item] === "number" &&
            addmLocations[i][item] === 1
          ) {
            if (!addmLocations[i]["addmbHousingStandards"])
              addmLocations[i]["addmbHousingStandards"] = [item];
            else addmLocations[i]["addmbHousingStandards"].push(item);
          }
          addmLocations[i]["docs"] = housing["docs"];
        }
      }
      setSecondary(housing["housingLocations"]);
      delete housing["housingLocations"];
    }
    setPrimary([housing]);
  }

  const queryResolver = (type) => {
    const resolver = {
      Initiated: GET_INITIATED_PAGINATED_DATA,
      Presubmitted: GET_PRESUBMITTED_PAGINATED_DATA,
      Submitted: GET_SUBMITTED_PAGINATED_DATA,
      Historical: GET_HISTORICAL_PAGINATED_DATA,
    };
    return resolver[type];
  };
  const { activeTab, filterBy } = useContext(CasesContext);

  let query = queryResolver(activeTab.machine_name);

  const findMatchingDocs = (docs, inspectionIndividualId) => {
    let matchedDocs = [];
    if (Array.isArray(docs) && docs.length > 0) {
      for (let i = 0; i < docs.length; i++) {
        for (let item in docs[i]) {
          if (
            item === "inspectionIndividualId" &&
            typeof docs[i][item] === "number" &&
            docs[i][item] === inspectionIndividualId
          ) {
            matchedDocs.push(docs[i]);
          }
        }
      }
    }
    return matchedDocs;
  };

  const primaryColumns = useMemo(
    () => [
      {
        Header: <FaRegBell />,
        accessor: "hasActiveInspNotification",
        id: "hasActiveInspNotification",
        fixedWidth: 40,
        Cell: ({ value, row: { index }, column: { id } }) => {
          return value === true && <Dot text={id} />;
        },
      },
      {
        Header: "Housing Type",
        accessor: "housingType",
        id: "housingType",
        Cell: ({ value, row: { index }, column: { id } }) => {
          return <span>{value || "--"}</span>;
        },
      },
      {
        Header: "Physical Location",
        accessor: "housingAddr1",
        id: "housingAddr1",
        Cell: ({ value, row: { index }, column: { id } }) => {
          return <span>{value || "--"}</span>;
        },
      },
      {
        Header: "Additional Information",
        accessor: "housingAddInfo",
        id: "housingAddInfo",
        Cell: ({ value, row: { index }, column: { id } }) => {
          return <span>{value || "--"}</span>;
        },
      },
      {
        Header: "Number of Units",
        accessor: "housingTotalUnits",
        id: "housingTotalUnits",
        fixedWidth: 120,
        Cell: ({ value, row: { index }, column: { id } }) => {
          return <span>{value || "--"}</span>;
        },
      },
      {
        Header: "Max Occupancy",
        accessor: "housingTotalOccupy",
        id: "housingTotalOccupy",
        fixedWidth: 120,
        Cell: ({ value, row: { index }, column: { id } }) => {
          return <span>{value || "--"}</span>;
        },
      },
      {
        Header: "Inspection Status",
        accessor: "inspectionStatus",
        id: "inspectionStatus",
        Cell: ({ value, row: { index }, column: { id } }) => {
          return <span>{value || "--"}</span>;
        },
      },
      {
        Header: "Inspection Entity",
        accessor: "housingStandards",
        id: "housingStandards",
        Cell: ({ value, row: { index }, column: { id } }) => {
          let standardArr = value;
          let displayVal = "";
          if (Array.isArray(standardArr) && standardArr?.length > 0) {
            for (let i = 0; i < standardArr.length; i++) {
              if (standardArr[i].includes("housingComp")) {
                //state is actually other state on V2
                if (standardArr[i] === "housingCompState") {
                  standardArr[i] = "housingCompOther State";
                }
                displayVal += `${standardArr[i].split("housingComp").pop()}, `;
              } else
                displayVal += `${standardArr[i].split("isCompliance").pop()}, `;
            }
          } else {
            displayVal = "--";
          }
          // remove trailing comma
          if (displayVal !== "--") displayVal = displayVal.slice(0, -2);
          return <span>{displayVal}</span>;
        },
      },
      {
        Header: "Results",
        accessor: "res",
        id: "res",
        fixedWidth: 130,
        Cell: ({ row, cell }) => {
          const expandedToggleProps = row.getToggleRowExpandedProps();
          return (
            <span {...expandedToggleProps} className="viewAccordion">
              {row.isExpanded ? "Hide Details" : "View Details"}
            </span>
          );
        },
      },
      {
        //invisible column to access inspection notes
        accessor: "housingInspectionNotes",
        id: "housingInspectionNotes",
        show: false,
        Cell: (props) => {
          return <span style={{ display: "none" }}>Accordion</span>;
        },
      },
      {
        //invisible column to access individualId
        accessor: "inspectionIndividualId",
        id: "inspectionIndividualId",
        show: false,
        Cell: (props) => {
          return <span style={{ display: "none" }}>Accordion</span>;
        },
      },
      {
        //invisible column to access docs
        accessor: "docs",
        id: "docs",
        show: false,
        Cell: (props) => {
          return <span style={{ display: "none" }}>Accordion</span>;
        },
      },
    ],
    []
  );

  const secondaryColumns = useMemo(
    () => [
      {
        Header: <FaRegBell />,
        accessor: "hasActiveInspNotification",
        id: "hasActiveInspNotification",
        fixedWidth: 40,
        Cell: ({ value, row: { index }, column: { id } }) => {
          return value === true && <Dot text={id} />;
        },
      },
      {
        Header: "Housing Type",
        accessor: "addmbHousingType",
        id: "addmbHousingType",
        Cell: ({ value, row: { index }, column: { id } }) => {
          return <span>{value || "--"}</span>;
        },
      },
      {
        Header: "Physical Location",
        accessor: "addmbHousingAddr1",
        id: "addmbHousingAddr1",
        Cell: ({ value, row: { index }, column: { id } }) => {
          return <span>{value || "--"}</span>;
        },
      },
      {
        Header: "Additional Information",
        accessor: "addmbHousingAdditionalInfo",
        id: "addmbHousingAdditionalInfo",
        Cell: ({ value, row: { index }, column: { id } }) => {
          return <span>{value || "--"}</span>;
        },
      },
      {
        Header: "Number of Units",
        accessor: "addmbHousingTotalUnits",
        id: "addmbHousingTotalUnits",
        fixedWidth: 120,
        Cell: ({ value, row: { index }, column: { id } }) => {
          return <span>{value || "--"}</span>;
        },
      },
      {
        Header: "Max Occupancy",
        accessor: "addmbHousingTotalOccupy",
        id: "addmbHousingTotalOccupy",
        fixedWidth: 120,
        Cell: ({ value, row: { index }, column: { id } }) => {
          return <span>{value || "--"}</span>;
        },
      },
      {
        Header: "Inspection Status",
        accessor: "inspectionStatus",
        id: "inspectionStatus",
        Cell: ({ value, row: { index }, column: { id } }) => {
          return <span>{value || "--"}</span>;
        },
      },
      {
        Header: "Inspection Entity",
        accessor: "addmbHousingStandards",
        id: "addmbHousingStandards",
        Cell: ({ value, row: { index }, column: { id } }) => {
          let standardArr = value;
          let displayVal = "";
          if (Array.isArray(standardArr) && standardArr?.length > 0) {
            for (let i = 0; i < standardArr.length; i++) {
              if (standardArr[i].includes("addmbHousingComply")) {
                //state is actually other state on V2
                if (standardArr[i] === "addmbHousingComplyState") {
                  standardArr[i] = "addmbHousingComplyOther State";
                }
                displayVal += `${standardArr[i]
                  .split("addmbHousingComply")
                  .pop()}, `;
              } else
                displayVal += `${standardArr[i]
                  .split("addmbIsCompliance")
                  .pop()}, `;
            }
          } else {
            displayVal = "--";
          }
          // remove trailing comma
          if (displayVal !== "--") displayVal = displayVal.slice(0, -2);
          return <span>{displayVal}</span>;
        },
      },
      {
        Header: "Results",
        accessor: "res",
        id: "res",
        fixedWidth: 130,
        Cell: ({ row, cell }) => {
          const expandedToggleProps = row.getToggleRowExpandedProps();
          return (
            <span {...expandedToggleProps} className="viewAccordion">
              {row.isExpanded ? "Hide Details" : "View Details"}
            </span>
          );
        },
      },
      {
        //invisible column to access inspection notes
        accessor: "housingInspectionNotes",
        id: "housingInspectionNotes",
        show: false,
        Cell: ({ value, row: { index }, column: { id } }) => {
          return <span style={{ display: "none" }}>Accordion</span>;
        },
      },
      {
        //invisible column to access individualId
        accessor: "inspectionIndividualId",
        id: "inspectionIndividualId",
        show: false,
        Cell: ({ value, row: { index }, column: { id } }) => {
          return <span style={{ display: "none" }}>Accordion</span>;
        },
      },
      {
        //invisible column to access docs
        accessor: "docs",
        id: "docs",
        show: false,
        Cell: ({ value, row: { index }, column: { id } }) => {
          return <span style={{ display: "none" }}>Accordion</span>;
        },
      },
    ],
    [secondaryHousing]
  );

  const accordionNoteColumns = useMemo(
    () => [
      {
        Header: "Date",
        accessor: "createdDate",
        id: "createdDate",
        fixedWidth: 200,
        Cell: ({ value, row: { index }, column: { id } }) => {
          let dateConvert = new Date(Number(value));
          let dateVal = moment(dateConvert).format("LL");
          return <>{dateVal || "--"}</>;
        },
      },
      {
        Header: "Title",
        accessor: "inspectionTitle",
        id: "inspectionTitle",
        fixedWidth: 200,
        Cell: ({ value, row: { index }, column: { id } }) => {
          return <>{value || "--"}</>;
        },
      },
      {
        Header: "Note",
        accessor: "inspectionNote",
        id: "inspectionNote",
        maxWidth: 1000,
        Cell: ({ value, row: { index }, column: { id } }) => {
          return <>{value || "--"}</>;
        },
      },
    ],
    []
  );
  const accordionDocColumns = useMemo(
    () => [
      {
        Header: "Date Received",
        accessor: "docCreatedDate",
        id: "docCreatedDate",
        fixedWidth: 200,
        Cell: ({ value, row: { index } }) => {
          value = Number(value);
          const _date = momentTimezone(value)
            .tz("America/New_York")
            .format("LL");
          return (
            <>
              <span data-tip data-for={`docCreatedDate${index}`}>
                {_date || "--"}
              </span>
              <ReactTooltip
                type="dark"
                effect="solid"
                id={`docCreatedDate${index}`}
              >
                <span>{_date || "--"}</span>
              </ReactTooltip>
            </>
          );
        },
      },
      {
        Header: "Document Name",
        accessor: "docName",
        id: "docName",
        fixedWidth: 300,
        sortType: function (a, b) {
          if (!manualPagination) {
            a = a.values.docName ? a.values.docName.toLowerCase() : "";
            b = b.values.docName ? b.values.docName.toLowerCase() : "";
            return a > b ? 1 : -1;
          }
        },
        Cell: ({ value, row: { index, original } }) => {
          const dhDocId = original?.dhDocId || "";
          const caseNumber = original?.caseNumber || "";
          const fileName = value;
          let [loading, setLoading] = useState(false);
          const handleGetDocument = async () => {
            setLoading(true);
            await getDocument({
              caseNumber,
              dhDocId,
              fileName,
            });
            setLoading(false);
          };
          return (
            <>
              {/**div over span because on long doc names, tooltip on the right column incorrectly shows  */}
              <div
                data-tip
                data-for={`docName_${index}`}
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  marginRight: 20,
                }}
              >
                {fileName || "--"}{" "}
                <div
                  className="case-documents-download-icon"
                  cursor="pointer"
                  onClick={() => {
                    handleGetDocument();
                  }}
                  // Allows keyboard navigation
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      handleGetDocument();
                    }
                  }}
                  tabIndex={0}
                >
                  {loading ? (
                    <FaSpinner className="icon-spin" />
                  ) : (
                    <FaDownload />
                  )}
                </div>
              </div>
              <ReactTooltip type="dark" effect="solid" id={`docName_${index}`}>
                <span>{fileName || "--"}</span>
              </ReactTooltip>
            </>
          );
        },
      },
      // {
      //   Header: "Submitted By",
      //   accessor: "submittedBy",
      //   id: "submittedBy",
      //   Cell: ({ cell: { value }, row: { index } }) => {
      //     return (
      //       <>
      //         <span data-tip data-for={`submittedBy_${index}`}>
      //           {value || "--"}
      //         </span>
      //         <ReactTooltip
      //           type="dark"
      //           effect="solid"
      //           id={`submittedBy_${index}`}
      //         >
      //           <span>{value || "--"}</span>
      //         </ReactTooltip>
      //       </>
      //     );
      //   },
      // },
    ],
    []
  );

  const [loading, setLoading] = React.useState(false);

  const renderHousingRowSubComponent = (row) => {
    const { housingInspectionNotes, docs, inspectionIndividualId } =
      row.original;
    const housingInspectionDocs = findMatchingDocs(
      docs,
      inspectionIndividualId
    );

    return (
      <StyledAccordion>
        {Array.isArray(housingInspectionNotes) ? (
          <>
            <h4>Housing Inspection Result Notes</h4>
            <ReactTable
              isExpandedRow={true}
              columns={accordionNoteColumns}
              data={housingInspectionNotes}
              loading={loading}
              tableTheme="housingSubRowTheme"
              noDataComponentText="No Records Available"
              defaultSortBy={[
                {
                  id: "createdDate",
                  desc: false,
                },
              ]}
              showPagination={true}
            />
            <h4>Housing Inspection Result Documents</h4>
            <ReactTable
              isExpandedRow={true}
              columns={accordionDocColumns}
              data={housingInspectionDocs}
              loading={loading}
              tableTheme="housingSubRowTheme"
              noDataComponentText="No Records Available"
              showPagination={true}
              defaultSortBy={[
                {
                  id: "docCreatedDate",
                  desc: false,
                },
              ]}
            />
          </>
        ) : null}
      </StyledAccordion>
    );
  };

  return (
    <>
      <h3>Housing Information</h3>
      <ReactTable
        columns={primaryColumns}
        data={primaryHousing}
        loading={loading}
        tableTheme="casesTableTheme"
        noDataComponentText="No Records Available"
        renderRowSubComponent={renderHousingRowSubComponent}
      />
      <h3>Additional Housing Information</h3>
      <ReactTable
        columns={secondaryColumns}
        data={secondaryHousing}
        loading={loading}
        tableTheme="casesTableTheme"
        noDataComponentText="No Records Available"
        renderRowSubComponent={renderHousingRowSubComponent}
      />
    </>
  );
}

export default (props) => (
  <ApolloConsumer>
    {(client) => (
      <HousingInspectionTable
        style={{ width: "100%" }}
        apolloClient={client}
        {...props}
      />
    )}
  </ApolloConsumer>
);
